module.exports = __webpack_public_path__ + "src/assets/img/product-peptide.f22a0471.png";